// batchingUtils.js
import dayjs from "dayjs";

export const isValidCriteriaDates = (values) => {
  return (
    values &&
    dayjs(values.FromCreatedDate).isValid() &&
    dayjs(values.ToCreatedDate).isValid()
  );
};
